import { render, staticRenderFns } from "./summaryB.vue?vue&type=template&id=24a9e406&scoped=true"
import script from "./summaryB.vue?vue&type=script&lang=js"
export * from "./summaryB.vue?vue&type=script&lang=js"
import style0 from "./summaryB.vue?vue&type=style&index=0&id=24a9e406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a9e406",
  null
  
)

export default component.exports